import {useState} from 'react';

// Custom hook to store a ref in state in order to add it to the dependency array in a useEffect when needed
export default function useElementRef() {
  const [element, setElement] = useState(null);
  const ref = (node) => {
    if (node !== null && node !== element) {
      setElement(node);
    }
  };
  return [element, ref];
}
